import { React, models, kea, history, resources, selectores, componentToRx, Route } from "app/main/std";
import { UsuarioApiList } from "./list";
import { UsuarioApiEdit } from "./edit";
import { OrigenUsuarioApiEdit } from "./edit/origen/edit";

export class UsuarioApiCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/UsuarioApi" component={UsuarioApiList} />
                <Route exact path="/catalogos/UsuarioApi/origen/:idUsuarioApi/:id" component={OrigenUsuarioApiEdit} />
                <Route exact path="/catalogos/UsuarioApi/:id" component={UsuarioApiEdit} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/index.tsx